import axios from "axios";
import { API_BASE_URL, STORAGE_KEYS } from "./ApisConstants";

export const CHAT_BACKEND_BASE_URL = API_BASE_URL;

const ChatHttp = axios.create({
  baseURL: CHAT_BACKEND_BASE_URL,
});

const readCookie = (cookieName) => {
  try {
    const cookies = document.cookie.split(";");
    for (const cookie of cookies) {
      const trimmed = cookie.trim();
      if (trimmed.startsWith(`${encodeURIComponent(cookieName)}=`)) {
        return decodeURIComponent(trimmed.substring(cookieName.length + 1));
      }
    }
  } catch (e) {
    console.warn("Failed to read cookie:", cookieName, e);
  }
  return null;
};

const onRequest = (config) => {
  // Inject Bearer token from cookie if not already set
  if (!config.headers?.Authorization) {
    const token = readCookie(STORAGE_KEYS.accessToken);
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      };
    }
  }
  return config;
};

const onRequestError = (error) => Promise.reject(error);

const onResponse = (response) => response;

const onResponseError = (error) => Promise.reject(error);

ChatHttp.interceptors.request.use(onRequest, onRequestError);
ChatHttp.interceptors.response.use(onResponse, onResponseError);

export default ChatHttp;
